import React, { useState, useEffect } from "react";
import "./Medium.css";
import "../../ui/styles/theme.css";

import { useParams, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import Loader from "../../ui/components/loader/Loader";
import ImageModal from "../../ui/components/image-modal/ImageModal";

const Medium = () => {
  const [isNavbarActive, setIsNavbarActive] = useState(false);
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [deliveryBoyMove, setDeliveryBoyMove] = useState(-80);
  const [lastScrollPos, setLastScrollPos] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { id } = useParams();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state
  //   const navigate=useNavigate();
  // Fetch user data from API
  //   const handleBuildButton=()=>{
  //       navigate("/")
  //   }
  const fetchUserData = async () => {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${url}/api/user/${id}`);
      if (response.ok) {
        const data = await response.json();
        setUser(data);
        setLoading(false); // Stop loader once data is fetched
      } else {
        console.error("User not found");
        setLoading(false); // Stop loader on error
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setLoading(false); // Stop loader on error
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [id]);

  // Handle scroll effects
  useEffect(() => {
    const handleScroll = () => {
      // Header sticky & back to top button
      if (window.scrollY >= 100) {
        setIsHeaderActive(true);
      } else {
        setIsHeaderActive(false);
      }

      // Move delivery boy on scroll
      const deliveryBoy = document.querySelector("[data-delivery-boy]");
      if (deliveryBoy) {
        const deliveryBoyTopPos = deliveryBoy.getBoundingClientRect().top;
        if (deliveryBoyTopPos < 500 && deliveryBoyTopPos > -250) {
          let activeScrollPos = window.scrollY;
          if (lastScrollPos < activeScrollPos) {
            setDeliveryBoyMove((prev) => prev + 1);
          } else {
            setDeliveryBoyMove((prev) => prev - 1);
          }
          setLastScrollPos(activeScrollPos);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollPos]);

  // Toggle navbar
  const toggleNavbar = () => {
    setIsNavbarActive((prev) => !prev);
  };

  // Toggle search box
  const toggleSearch = () => {
    setIsSearchActive((prev) => !prev);
    document.body.classList.toggle("active");
  };

  // Scroll to contact section
  const scrollToContact = () => {
    toggleNavbar();
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // Handle form submission for contact
  const handleContactSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const businessType = formData.get('business_type');
    const details = formData.get('details');
    const budget = formData.get('budget');
    
    // Create email message
    const subject = encodeURIComponent('New Business Inquiry from WebDPro Website');
    const body = encodeURIComponent(`Hello WebDPro,

I'm interested in your services.

Business Type: ${businessType}

Details: ${details}

Budget: ${budget}

Best regards`);
    
    // Open email client with pre-filled message
    window.location.href = `mailto:contact@webdpro.in?subject=${subject}&body=${body}`;
    
    // Reset form
    e.target.reset();
    
    // Show confirmation message
    alert('Thank you for your inquiry! We will contact you shortly via email.');
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      {/* HEADER */}
      <header
        className={`header ${isHeaderActive ? "active" : ""}`}
        data-header
      >
        <div className="container">
          <div className="logo-container-medium">
            <a href="#">
              <img
                src={user.personalInfo?.logo_img || ""}
                alt="resturant logo"
                className="logo-img"
              />
            </a>
            <h1>
              <a href="#" className="logo">
                {user.personalInfo?.name || ""}
              </a>
            </h1>
          </div>

          <nav
            className={`navbar ${isNavbarActive ? "active" : ""}`}
            data-navbar
          >
            <ul className="navbar-list">
              <li className="nav-item">
                <a href="#home" className="navbar-link" onClick={toggleNavbar}>
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a href="#about" className="navbar-link" onClick={toggleNavbar}>
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#food-menu"
                  className="navbar-link"
                  onClick={toggleNavbar}
                >
                  Shop
                </a>
              </li>
              <li className="nav-item">
                <a 
                  href="#contact" 
                  className="navbar-link" 
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToContact();
                  }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </nav>

          <div className="header-btn-group">
            <button
              className="search-btn"
              aria-label="Search"
              onClick={toggleSearch}
            >
              <ion-icon name="search-outline"></ion-icon>
            </button>

            <button
              className="btn btn-hover"
              onClick={() =>
                window.open(
                  `https://wa.me/+91${user?.personalInfo?.whatsapp}?text=Hi%2C%20I%20want%20to%20book%20a%20table%20on%20:`,
                  "_blank"
                )
              }
            >
              Reservation
            </button>

            <button
              className={`nav-toggle-btn ${isNavbarActive ? "active" : ""}`}
              aria-label="Toggle Menu"
              onClick={toggleNavbar}
            >
              <span className="line top"></span>
              <span className="line middle"></span>
              <span className="line bottom"></span>
            </button>
          </div>
        </div>
      </header>

      {/* SEARCH BOX */}
      <div
        className={`search-container ${isSearchActive ? "active" : ""}`}
        data-search-container
      >
        <div className="search-box">
          <input
            type="search"
            name="search"
            aria-label="Search here"
            placeholder="Type keywords here..."
            className="search-input"
          />

          <button
            className="search-submit"
            aria-label="Submit search"
            onClick={toggleSearch}
          >
            <ion-icon name="search-outline"></ion-icon>
          </button>
        </div>

        <button
          className="search-close-btn"
          aria-label="Cancel search"
          onClick={toggleSearch}
        ></button>
      </div>

      <main>
        <article>
          {/* HERO */}
         <section
            className="hero"
            id="home"
            style={{ backgroundImage: "url('/assets/images/hero-bg.jpg')" }}
          >
            <div className="container">
              <div className="hero-content">

                <h2 className="h1 hero-title">
                  {user?.personalInfo?.name || "Webdpro Solutions Private Limited"}
                </h2>
                <p className="hero-text">
                  We are a leading digital solutions company specializing in creating innovative web and mobile applications. 
                  Our team of experts delivers cutting-edge technology solutions tailored to your business needs.
                </p>
                <button
                  className="btn"
                  onClick={() =>
                    window.open(
                      `https://wa.me/+91${user?.personalInfo?.whatsapp}?text=Hi%2C%20I%20want%20to%20book%20a%20table%20on%20:`,
                      "_blank"
                    )
                  }
                >
                  Get Started
                </button>
              </div>
              <figure className="hero-banner">
                <img
                  src="/assets/images/hero-banner-bg.png"
                  width="820"
                  height="716"
                  alt=""
                  aria-hidden="true"
                  className="w-100 hero-img-bg"
                />
                <img
                  src={user?.background[0]?.background_img || ""}
                  width="700"
                  height="637"
                  loading="lazy"
                  alt={user?.background[0]?.background_name || ""}
                  className="w-100 hero-img"
                />
              </figure>
            </div>
          </section> 

          {/* WHY CHOOSE US */}
          <section className="section why-choose-us">
            <div className="container">
              <h2 className="h2 section-title">Why Choose WebDPro?</h2>
              <p className="section-text">
                We stand out in the digital landscape with our commitment to excellence and innovation.
              </p>
              
              <div className="features-grid">
                <div className="feature-card">
                  <div className="feature-icon">
                    <ion-icon name="rocket-outline"></ion-icon>
                  </div>
                  <h3 className="h3 feature-title">Fast Delivery</h3>
                  <p className="feature-text">
                    We deliver projects on time without compromising on quality.
                  </p>
                </div>
                
                <div className="feature-card">
                  <div className="feature-icon">
                    <ion-icon name="shield-checkmark-outline"></ion-icon>
                  </div>
                  <h3 className="h3 feature-title">Secure Solutions</h3>
                  <p className="feature-text">
                    Our applications are built with security as a top priority.
                  </p>
                </div>
                
                <div className="feature-card">
                  <div className="feature-icon">
                    <ion-icon name="people-outline"></ion-icon>
                  </div>
                  <h3 className="h3 feature-title">Expert Team</h3>
                  <p className="feature-text">
                    Our team of experienced developers ensures top-notch results.
                  </p>
                </div>
                
                <div className="feature-card">
                  <div className="feature-icon">
                    <ion-icon name="phone-portrait-outline"></ion-icon>
                  </div>
                  <h3 className="h3 feature-title">Responsive Design</h3>
                  <p className="feature-text">
                    All our solutions work flawlessly on any device.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* ABOUT */}
          {user?.discounts?.length > 0 && (
          <section className="section section-divider gray about" id="about">
            <div className="container">
              <div className="about-banner">
                <img
                  // src="/assets/images/about-banner.png"
                  src={user?.discounts[0]?.discount_img || ""}
                  width="509"
                  height="459"
                  loading="lazy"
                  alt={user?.discounts[0]?.name || ""}
                  className="w-100 about-img"
                />
                <img
                  src="/assets/images/sale-shape-red.png"
                  width="216"
                  height="226"
                  alt="get up to 50% off now"
                  className="abs-img scale-up-anim w-[216px] h-[226px] sm:w-[150px] sm:h-[160px]"
                />
              </div>

              <div className="about-content">
                <h2 className="h2 section-title">
                  {user?.discounts[0]?.name || ""}
                </h2>
                <h2 className="h2 section-title">
                  <span className="span">
                    ₹ {user?.discounts[0]?.discount || ""}
                  </span>
                </h2>

                <p className="section-text">
                  {user?.discounts[0]?.description || ""}
                </p>
                <ul className="about-list">
                  <li className="about-item">
                    <ion-icon name="checkmark-outline"></ion-icon>
                    <span className="span">Delicious & Healthy Foods</span>
                  </li>
                  <li className="about-item">
                    <ion-icon name="checkmark-outline"></ion-icon>
                    <span className="span">Spacific Family And Kids Zone</span>
                  </li>
                  <li className="about-item">
                    <ion-icon name="checkmark-outline"></ion-icon>
                    <span className="span">Music & Other Facilities</span>
                  </li>
                  <li className="about-item">
                    <ion-icon name="checkmark-outline"></ion-icon>
                    <span className="span">Fastest Food Home Delivery</span>
                  </li>
                </ul>
                <button
                  className="btn btn-hover"
                  onClick={() =>
                    window.open(
                      `https://wa.me/+91${user?.personalInfo?.whatsapp}?text=Hi%2C%20I%20want%20to%20Order%20:`,
                      "_blank"
                    )
                  }
                >
                  Order Now
                </button>
              </div>
            </div>
          </section>
          )}

          {/* FOOD MENU */}
          {user?.items?.length > 0 && ( <section className="section food-menu" id="food-menu">
            <div className="container">
              <p className="section-subtitle">Popular Dishes</p>
              <h2 className="h2 section-title">
                Our Delicious <span className="span">Foods</span>
              </h2>
              <p className="section-text">
                Food is any substance consumed to provide nutritional support
                for an organism.
              </p>
              {/* <ul className="fiter-list">
                <li>
                  <button className="filter-btn active">All</button>
                </li>
                <li>
                  <button className="filter-btn">Pizza</button>
                </li>
                <li>
                  <button className="filter-btn">Burger</button>
                </li>
                <li>
                  <button className="filter-btn">Drinks</button>
                </li>
                <li>
                  <button className="filter-btn">Sandwich</button>
                </li>
              </ul> */}

              <ul className="food-menu-list">
                {user?.items?.map((item) => (
                  <li key={item.id}>
                    <div className="food-menu-card">
                      <div className="card-banner">
                        <img
                          src={item.item_img}
                          width="300"
                          height="300"
                          loading="lazy"
                          alt={item.item_name}
                          className="w-100"
                        />
                        <div className="badge">{item.item_discount}</div>
                        <button
                          className="btn food-menu-btn"
                          onClick={() =>
                            window.open(
                              `https://wa.me/+91${user?.personalInfo?.whatsapp}?text=Hi%2C%20I%20want%20to%20Order%20${item.item_name}:`,
                              "_blank"
                            )
                          }
                        >
                          Order Now
                        </button>
                      </div>
                      <div className="wrapper">
                        {/* <p className="category">{item.item_category}</p> */}
                        {/* <div className="rating-wrapper">
                          {Array(item.rating).fill().map((_, i) => (
                            <ion-icon key={i} name="star"></ion-icon>
                          ))}
                        </div> */}
                      </div>
                      <h3 className="h3 card-title">{item.item_name}</h3>
                      <div className="price-wrapper">
                        <p className="price-text">Price:</p>
                        <data className="price">₹ {item.item_price}</data>
                        {/* <del className="del">{item.originalPrice}</del> */}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </section>)}
          {/* CTA */}
          {user?.special_item?.special_name!="" && ( <section
            className="section section-divider white cta"
            style={{ backgroundImage: "url('/assets/images/hero-bg.jpg')" }}
          >
            <div className="container">
              <div className="cta-content">
                <h2 className="h2 section-title">
                  {user?.special_item?.special_name || ""}
                  <span className="span">
                    ₹ {user?.special_item?.special_price || ""}
                  </span>
                </h2>
                <p className="section-text">
                  {user?.special_item?.special_description || ""}
                </p>
                <button className="btn btn-hover">Order Now</button>
              </div>
              <figure className="cta-banner">
                <img
                  src={user?.special_item.special_img || ""}
                  width="700"
                  height="637"
                  loading="lazy"
                  alt={user?.special_item?.special_name || ""}
                  className="w-100 cta-img"
                />
                <img
                  src="/assets/images/sale-shape.png"
                  width="216"
                  height="226"
                  loading="lazy"
                  alt="get up to 50% off now"
                  className="abs-img scale-up-anim"
                />
              </figure>
            </div>
          </section>)}
        

          {/* DELIVERY */}
          <section className="section section-divider gray delivery">
            <div className="container">
              <div className="delivery-content">
                <h2 className="h2 section-title">
                  A Moments Of Delivered On{" "}
                  <span className="span">Right Time</span> & Place
                </h2>
                <p className="section-text">
                  The restaurants in Hangzhou also catered to many northern
                  Chinese who had fled south from Kaifeng during the Jurchen
                  invasion of the 1120s, while it is also known that many
                  restaurants were run by families.
                </p>
                <button className="btn btn-hover">Order Now</button>
              </div>
              <figure className="delivery-banner">
                <img
                  src="/assets/images/delivery-banner-bg.png"
                  width="700"
                  height="602"
                  loading="lazy"
                  alt="clouds"
                  className="w-100"
                />
                <img
                  src="/assets/images/delivery-boy.svg"
                  width="1000"
                  height="880"
                  loading="lazy"
                  alt="delivery boy"
                  className="w-100 delivery-img"
                  data-delivery-boy
                  style={{ transform: `translateX(${deliveryBoyMove}px)` }}
                />
              </figure>
            </div>
          </section>

          {/* TESTIMONIALS */}
          {user?.testimonial?.length > 0 && (
            <section className="section section-divider white testi">
              <div className="container">
                <p className="section-subtitle">Testimonials</p>
                <h2 className="h2 section-title">
                  Our Customers <span className="span">Reviews</span>
                </h2>
                <p className="section-text">
                  Food is any substance consumed to provide nutritional support
                  for an organism.
                </p>
                <ul className="testi-list has-scrollbar">
                  {user?.testimonial?.map((testimonial) => (
                    <li className="testi-item" key={testimonial.id}>
                      <div className="testi-card">
                        <div className="profile-wrapper">
                          <figure className="avatar">
                            {/* <img src={testimonial.avatar} width="80" height="80" loading="lazy" alt={testimonial.name} /> */}
                          </figure>
                          <div>
                            <h3 className="h4 testi-name">
                              {testimonial.name}
                            </h3>
                            {/* <p className="testi-title">{testimonial.title}</p> */}
                          </div>
                        </div>
                        <blockquote className="testi-text">
                          {testimonial.description}
                        </blockquote>
                        <div className="rating-wrapper">
                          <ion-icon name="star"></ion-icon>
                          <ion-icon name="star"></ion-icon>
                          <ion-icon name="star"></ion-icon>
                          <ion-icon name="star"></ion-icon>
                          <ion-icon name="star"></ion-icon>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
          )}

          {/* BLOG */}
          {/* <section className="section section-divider white blog" id="blog">
            <div className="container">
              <p className="section-subtitle">Latest Blog Posts</p>
              <h2 className="h2 section-title">
                This Is All About <span className="span">Foods</span>
              </h2>
              <p className="section-text">
                Food is any substance consumed to provide nutritional support for an organism.
              </p>
              <ul className="blog-list">
                {blogPosts.map(post => (
                  <li key={post.id}>
                    <div className="blog-card">
                      <div className="card-banner">
                        <img src={post.image} width="600" height="390" loading="lazy" alt={post.title} className="w-100" />
                        <div className="badge">{post.category}</div>
                      </div>
                      <div className="card-content">
                        <div className="card-meta-wrapper">
                          <a href="#" className="card-meta-link">
                            <ion-icon name="calendar-outline"></ion-icon>
                            <time className="meta-info" dateTime="2022-01-01">{post.date}</time>
                          </a>
                          <a href="#" className="card-meta-link">
                            <ion-icon name="person-outline"></ion-icon>
                            <p className="meta-info">{post.author}</p>
                          </a>
                        </div>
                        <h3 className="h3">
                          <a href="#" className="card-title">{post.title}</a>
                        </h3>
                        <p className="card-text">
                          {post.excerpt}
                        </p>
                        <a href="#" className="btn-link">
                          <span>Read More</span>
                          <ion-icon name="arrow-forward" aria-hidden="true"></ion-icon>
                        </a>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </section> */}
        </article>
      </main>

      {/* FOOTER */}
      <footer className="footer" id="contact">
        <div
          className="footer-top"
          style={{
            backgroundImage: "url('/assets/images/footer-illustration.png')",
          }}
        >
          <div className="container">
            <div className="footer-brand">
              <a href="" className="logo">
                {user.personalInfo?.name || "WebDPro"}<span className="span">.</span>
              </a>
              <p className="footer-text">
                Transforming businesses through innovative digital solutions.
              </p>
              <ul className="social-list">
                <li>
                  <a href="#" className="social-link">
                    <ion-icon name="logo-facebook"></ion-icon>
                  </a>
                </li>
                <li>
                  <a href="#" className="social-link">
                    <ion-icon name="logo-twitter"></ion-icon>
                  </a>
                </li>
                <li>
                  <a href="#" className="social-link">
                    <ion-icon name="logo-instagram"></ion-icon>
                  </a>
                </li>
                <li>
                  <a href="#" className="social-link">
                    <ion-icon name="logo-linkedin"></ion-icon>
                  </a>
                </li>
              </ul>
            </div>

            <ul className="footer-list">
              <li>
                <p className="footer-list-title">Contact Info</p>
              </li>
              <li>
                <p className="footer-list-item">
                  <ion-icon name="call-outline"></ion-icon>
                  {user.personalInfo.phone || ""}
                </p>
              </li>
              <li>
                <p className="footer-list-item">
                  <ion-icon name="mail-outline"></ion-icon>
                  {user.personalInfo.email || ""}
                </p>
              </li>
              <li>
                <address className="footer-list-item">
                  <ion-icon name="location-outline"></ion-icon>
                  {user.personalInfo.location || ""}
                </address>
              </li>
            </ul>

            <ul className="footer-list">
              <li>
                <p className="footer-list-title">Opening Hours</p>
              </li>
              <li>
                <p className="footer-list-item">
                  {user.personalInfo?.Timings || "Monday-Sunday"}{" "}
                </p>
              </li>
              <li>
                <a
                  className="footer-list-item"
                  href={user.personalInfo?.facebook || "#home"}
                >
                  <ion-icon name="logo-facebook"></ion-icon> Facebook{" "}
                </a>
              </li>
              <li>
                <a
                  className="footer-list-item"
                  href={user.personalInfo?.instagram || "#home"}
                >
                  <ion-icon name="logo-instagram"></ion-icon> Instagram{" "}
                </a>
              </li>
            </ul>

            <form onSubmit={handleContactSubmit} className="footer-form">
              <p className="footer-list-title">Get In Touch</p>
              <div className="input-wrapper">
                <input
                  type="text"
                  name="business_type"
                  required
                  placeholder="Type of Business"
                  aria-label="Type of Business"
                  className="input-field"
                />
                <input
                  type="text"
                  name="budget"
                  required
                  placeholder="Budget Range"
                  aria-label="Budget Range"
                  className="input-field"
                />
              </div>

              <textarea
                name="details"
                required
                placeholder="Project Details"
                aria-label="Project Details"
                className="input-field"
              ></textarea>
              <button type="submit" className="btn">
                Send via Mail
              </button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <p className="copyright-text">
              &copy; 2026 Webdpro Solutions Private Limited. All rights reserved.
            </p>
            <div>
              <a href="/policy-pages/privacy-policy.html">Privacy Policy</a> &nbsp;|&nbsp;
              <a href="/policy-pages/terms-and-conditions.html">Terms &amp; Conditions</a> &nbsp;|&nbsp;
              <a href="/policy-pages/cancellation-refund-policy.html">Refund &amp; Cancellation</a> &nbsp;|&nbsp;
              <a href="/policy-pages/shipping-delivery-policy.html">Shipping &amp; Delivery</a>
            </div>
          </div>
        </div>
      </footer>

      {/* BACK TO TOP */}
      <a
        href="#top"
        className={`back-top-btn ${isHeaderActive ? "active" : ""}`}
        aria-label="Back to top"
        data-back-top-btn
      >
        <ion-icon name="chevron-up"></ion-icon>
      </a>
    </>
  );
};

export default Medium;